import {DateTime} from "luxon";

const convertDateByTimezone = (zone: string) => {
    return DateTime.now().setZone(zone);
};

export default convertDateByTimezone;